<div class="markdown m-2 max-w-7xl mx-auto px-4">
  <h1 class="text-4xl font-bold text-green-900 mb-8 text-center">About Sencha Tea</h1>
  
  <!-- First section - Sydney -->
  <div class="flex flex-col md:flex-row items-center gap-8 mb-12">
    <div class="md:w-1/2">
      <img 
        [src]="'/assets/about/sydney.jpg' | imageModifier:{width:750} | async" 
        class="w-full rounded-lg shadow-lg hover:shadow-xl transition-shadow duration-300"
      />
    </div>
    <p class="md:w-1/2 text-lg">
      Welcome to Sencha Tea, your gateway to authentic, high-quality loose-leaf 
      teas from around the world. Based in the heart of Sydney, Australia, we 
      are passionate about sourcing the finest teas and sharing them with tea 
      lovers everywhere.
    </p>
  </div>

  <!-- Second section - Sourcing -->
  <div class="flex flex-col md:flex-row-reverse items-center gap-8 mb-12">
    <div class="md:w-1/2">
      <img 
        [src]="'/assets/about/sourcing.jpg' | imageModifier:{width:750} | async" 
        class="w-full rounded-lg shadow-lg hover:shadow-xl transition-shadow duration-300"
      />
    </div>
    <p class="md:w-1/2 text-lg">
      Our journey begins with a commitment to authenticity and excellence. We 
      meticulously select teas that not only reflect their origins but also 
      offer a truly remarkable experience in every cup.
    </p>
  </div>

  <!-- Third section - Worldwide -->
  <div class="flex flex-col md:flex-row items-center gap-8 mb-12">
    <div class="md:w-1/3">
      <img 
        [src]="'assets/about/worldwide.jpg' | imageModifier:{width:500} | async" 
        class="w-full rounded-lg shadow-lg hover:shadow-xl transition-shadow duration-300"
      />
    </div>
    <p class="md:w-2/3 text-lg">
      With a global reach, we are proud to deliver our teas to customers 
      worldwide, ensuring that no matter where you are, you can enjoy the 
      richness of our carefully curated selections. Our nationally and 
      internationally trademarked brand is a testament to our pursuit of trust, 
      quality, and consistency.
    </p>
  </div>

  <p class="text-lg text-center max-w-3xl mx-auto italic">
    For us, tea isn't a product, it's a journey! Tea brings health benefits and 
    traditions we are honoured to share with you. Join us in celebrating the art
    of tea, one cup at a time.
  </p>
</div>
